// extracted by mini-css-extract-plugin
export default {"form":"login_form-module__form--3bwQX"};